<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="ADVANCED_FILTER_STATUS_OPTIONS"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
></pp-advanced-filter-option-select>

@if (option === EAdvancedFilterOptions.IS || option === EAdvancedFilterOptions.IS_NOT) {
  <pp-advanced-filter-option-select
    class="advancedFilter__option"
    [ppItems]="ADVANCED_FILTER_STATUS_VALUES"
    [ppOption]="value[0]"
    (ppOptionChange)="changeFieldValue($event)"
    ppClass="advancedFilter__option--long"
  ></pp-advanced-filter-option-select>
}

@if (
  option === EAdvancedFilterOptions.IS_ANY_OF || option === EAdvancedFilterOptions.IS_NONE_OF
  ) {
  <pp-select-multiple
    class="advancedFilter__option"
    [ppId]="'statusFilter' + ppIndex"
    [ppItems]="ADVANCED_FILTER_STATUS_VALUES"
    ppClass="advancedFilter__option--long"
    [ppNoSearchBar]="true"
    (ppSelectItem)="changeFieldValueMultiple()"
    ppIconClass="setSize18"
  ></pp-select-multiple>
}
